import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import Icon from '../Icon/Icon';
const ButtonIcon = ({ className, variant }) => {
    return _jsx(Icon, { className: clsx('h-1 w-1', className), variant: variant });
};
export default ButtonIcon;
